// The seconds left of my move in an online card game (owner 2026-10-29: 20 s, 30 s for Kierki's pass), next to the
// table's hint; the last 5 stand out. Nothing offline (no deadline there).
import { useEffect, useState } from 'react';
import { t } from '../i18n';
import { useSeatWait, useTurnSeconds } from './common';

export function TurnClock({ at }: { at: number | null | undefined }) {
  const s = useTurnSeconds(at);
  if (s === null) return null;
  return (
    <span className="mp_turn_clock" role="timer" data-low={s <= 5 || undefined}>
      {t('lobby.turn-clock', { s })}
    </span>
  );
}

/** The fade of the wait clock, in and out (hearts.css). */
const WAIT_FADE_MS = 160;

/** Beside another player's plate (under their chip on a phone), outside its frame: the seconds left of their move,
 *  shown once they have thought 5 s and counting down to 0 (owner 2026-11-02: a long think looked like a stuck game;
 *  outside the frame, so a long name never stretches the plate; a quick fade in and out). Online only. */
export function SeatWait({ seat }: { seat: number }) {
  const s = useSeatWait(seat);
  // the last number stays while the clock fades out
  const [shown, setShown] = useState<number | null>(null);
  useEffect(() => {
    if (s !== null) {
      setShown(s);
      return undefined;
    }
    const id = window.setTimeout(() => setShown(null), WAIT_FADE_MS);
    return () => clearTimeout(id);
  }, [s]);
  const value = s ?? shown;
  if (value === null) return null;
  return (
    <span className="mp_seat_wait" role="timer" data-leaving={s === null || undefined}>
      <i aria-hidden="true" />
      {t('lobby.turn-clock', { s: value })}
    </span>
  );
}
